export default "__VITE_ASSET__7cfa99b5__"